import { images as desktopImages } from './desktop';
import { images as mobileImages } from './mobile';

export const images = {
  desktop: desktopImages,
  mobile: mobileImages,
};
